export const VERIFICATION_REPORT = 'Verification Report';
export const VERIFICATION_REQUEST_OUTDATED_DAYS = 60;
//# sourceMappingURL=verificationRequest.js.map